import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Button, Select, Box, Text, Image } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useFetch } from "../../../../../hooks/useFetch";
import { CustomTable, CustomToast } from "../../../../../components";
import { hiringCategoryList } from "../../CandidateList/modal";
import { Column } from "../../../../../components/CustomTable/customTable";
import { DownloadIcon } from "@chakra-ui/icons";
import { showDateTime } from "../../../../../utilities/helper";

export default function GenerateQrModal({ isOpen, onClose, jobData }: any) {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    const [selectedHiringCategory, setSelectedHiringCategory] = useState<string>("");
    const [qrList, setQrList] = useState<any[]>([]);
    const [previewImage, setPreviewImage] = useState<string | null>(null);

    const loadQrList = async () => {
        const res = await fetchApi(`JobOpening/getJobQr?job_Id=${jobData.id}`, "GET");
        if (res) setQrList(res);
    };

    useEffect(() => {
        if (isOpen) loadQrList();
    }, [isOpen]);


    const handleSubmit = async () => {
        if (!selectedHiringCategory) {
            addToast({ message: "Please select a hiring category", status: "error" });
            return;
        }

        let payload = {
            job_Id: jobData.id,
            hiring_Category_Id: Number(selectedHiringCategory),
            hiring_Category: hiringCategoryList.find(cat => cat.id === Number(selectedHiringCategory))?.category
        };

        const response = await fetchApi("JobOpening/generateJobQrCode", "POST", payload);

        if (response) {
            addToast({ message: "QR Code generated successfully", status: "success" });
            await loadQrList();
            setSelectedHiringCategory("");
        }
    };

    const closePreview = () => setPreviewImage(null);


    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose} isCentered size="4xl">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Generate QR Code</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Box mb={4}>
                            <Text fontSize="sm" mb={1} fontWeight="500"> Hiring Category <Text as="span" color="red">*</Text> </Text>

                            <Select placeholder="Select Hiring Category" value={selectedHiringCategory} onChange={(e) => setSelectedHiringCategory(e.target.value)} >
                                {hiringCategoryList.map((w) => (
                                    <option key={w.id} value={w.id}>
                                        {w.category}
                                    </option>
                                ))}
                            </Select>
                        </Box>
                        <ModalFooter>
                            <Button isLoading={loading} colorScheme="green" onClick={handleSubmit}>
                                Generate
                            </Button>
                        </ModalFooter>
                        <Box mt={4}>
                            {qrList.length === 0 ? (
                                <Text fontSize="sm" color="gray.500">No QR codes generated yet.</Text>
                            ) : (
                                <CustomTable value={qrList} loading={loading} emptyMessage="No Qr found">
                                    <Column header="Hiring Category" body={(row: any) => {
                                        const cat = hiringCategoryList.find(x => x.id === row.hiring_Category);
                                        return cat ? cat.category : "-";
                                    }}
                                    />
                                    <Column field="file_Url" header="QR Image" body={(row: any) => (<Image src={row.file_Url} alt="QR" boxSize="50px" cursor="pointer" onClick={() => setPreviewImage(row.file_Url)} />)} />
                                    <Column field="created_By" header="Created By" />
                                    <Column field="generated_On" header="Generated On" body={r => showDateTime(r.generated_On)} />
                                </CustomTable>
                            )}
                        </Box>
                    </ModalBody>
                </ModalContent>
            </Modal>
            <Modal isOpen={!!previewImage} onClose={closePreview} isCentered size="lg">
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>QR Code Preview</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody textAlign="center">
                        <Image src={previewImage!} alt="QR-Code" width="300px" margin="auto" />
                    </ModalBody>
                    <ModalFooter>
                        <a href={previewImage!} download>
                            <Button colorScheme="blue" leftIcon={<DownloadIcon />} />
                        </a>


                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
}

